const CATEGORY_SLUG_ALIASES: Record<string, string> = {
  "artificial-intelligence": "ai",
  "e-commerce": "ecommerce",
  "crypto-and-web3": "crypto-web3",
  "health-and-fitness": "health-fitness",
  "news-and-magazines": "news-magazines",
  "recruiting-and-hr": "recruiting",
  "recruiting-hr": "recruiting"
};

const SLUG_TO_MIRROR_CATEGORY: Record<string, string> = {
  ai: "artificial intelligence",
  ecommerce: "e-commerce",
  "crypto-web3": "crypto & web3",
  "health-fitness": "health & fitness",
  "news-magazines": "news & magazines",
  recruiting: "recruiting & hr"
};

function decodeSafely(raw: string): string {
  try {
    return decodeURIComponent(raw);
  } catch {
    return raw;
  }
}

function toSlugLikeValue(value: string): string {
  return value
    .toLowerCase()
    .trim()
    .replace(/&/g, " and ")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/-+/g, "-")
    .replace(/^-|-$/g, "");
}

/**
 * Normalizes user-provided URL slugs and mirror category names to the site's
 * canonical category slugs.
 */
export function normalizeCategorySlug(raw: string): string {
  const decoded = decodeSafely(raw);
  const slugLike = toSlugLikeValue(decoded);
  return CATEGORY_SLUG_ALIASES[slugLike] ?? slugLike;
}

/**
 * Converts the site's canonical slug to the exact category label used in the
 * TrustMRR mirror database.
 */
export function slugToMirrorCategory(slug: string): string {
  const normalizedSlug = normalizeCategorySlug(slug);
  return SLUG_TO_MIRROR_CATEGORY[normalizedSlug] ?? normalizedSlug.replace(/-/g, " ");
}
